var Annotation = require('../annotation');

var Emphasis = Annotation.extend({
  name: "emphasis",
  displayName: "Emphasis",
  splitContainerSelections: true
});

Emphasis.static.tagName = "em";

Emphasis.static.matchElement = function($el) {
  return $el.is("em,i");
};

module.exports = Emphasis;



/*****************
 ** WEBPACK FOOTER
 ** ./~/substance/document/nodes/emphasis.js
 ** module id = 135
 ** module chunks = 0
 **/